/* eslint-disable no-console */
import { sendErrorAnalytics } from '../../catalog/Analytics';
import { EVENT_DOES_NOT_EXIST, FETCH_EVENTS_AND_PRACTICE_ERROR, FETCH_EVENTS_ERROR, FETCH_EVENT_ERROR, FETCH_PRACTICE_ERROR } from '../../catalog/NotificationsComments';
import { databaseTagsToLocalTags } from '../../catalog/Tags';
import { optimXTesting } from '../../catalog/TeamInfo';
import { fetchEventFirestoreAPI, fetchUpcomingEventsAndPracticeFirestoreAPI, fetchUpcomingEventsFirestoreAPI, fetchLimitedUpcomingEventsAndPracticeFirestoreAPI, fetchUpcomingPracticesFirestoreAPI, fetchLimitedPastEventsAndPracticeFirestoreAPI, fetchPastPracticesFirestoreAPI, fetchPastEventsFirestoreAPI, fetchPastEventsAndPracticeFirestoreAPI, fetchLimitedPastPracticeFirestoreAPI, fetchLimitedUpcomingPracticeFirestoreAPI, fetchLimitedPastEventsFirestoreAPI, fetchLimitedUpcomingEventsFirestoreAPI } from '../../firebase/firebaseAPICalls/FirebaseAPICallsEvent';

export const fetchUpcomingEventsAndPracticeAPI = async (teamId: string, setState: Function, snackbar: Function) => {
    const events: any = [];
    try {
        const docs = await fetchUpcomingEventsAndPracticeFirestoreAPI(teamId);
        docs.forEach((doc) => {
            if (doc.exists) {
                events.push({ ...doc.data() });
            }
        });
        setState({ type: 'fetchUpcomingEvents', events });
    } catch (error) {
        sendErrorAnalytics(FETCH_EVENTS_AND_PRACTICE_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_EVENTS_AND_PRACTICE_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchPastEventsAndPracticeAPI = async (teamId: string, setState: Function, snackbar: Function) => {
    const events: any = [];
    try {
        const docs = await fetchPastEventsAndPracticeFirestoreAPI(teamId);
        docs.forEach((doc) => {
            if (doc.exists) {
                events.push({ ...doc.data() });
            }
        });
        setState({ type: 'fetchPastEvents', events });
    } catch (error) {
        sendErrorAnalytics(FETCH_EVENTS_AND_PRACTICE_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_EVENTS_AND_PRACTICE_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchUpcomingEventsAPI = async (teamId: string, setState: Function, snackbar: Function) => {
    const events: any = [];
    try {
        const docs = await fetchUpcomingEventsFirestoreAPI(teamId);
        docs.forEach((doc) => {
            if (doc.exists) {
                events.push({ ...doc.data() });
            }
        });
        setState({ type: 'fetchUpcomingEvents', events });
    } catch (error) {
        sendErrorAnalytics(FETCH_EVENTS_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_EVENTS_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchPastEventsAPI = async (teamId: string, setState: Function, snackbar: Function) => {
    const events: any = [];
    try {
        const docs = await fetchPastEventsFirestoreAPI(teamId);
        docs.forEach((doc) => {
            if (doc.exists) {
                events.push({ ...doc.data() });
            }
        });
        setState({ type: 'fetchPastEvents', events });
    } catch (error) {
        sendErrorAnalytics(FETCH_EVENTS_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_EVENTS_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchUpcomingPracticeAPI = async (teamId: string, setState: Function, snackbar: Function) => {
    const events: any = [];
    try {
        const docs = await fetchUpcomingPracticesFirestoreAPI(teamId);
        docs.forEach((doc) => {
            if (doc.exists) {
                events.push({ ...doc.data() });
            }
        });
        setState({ type: 'fetchUpcomingPractice', events });
    } catch (error) {
        sendErrorAnalytics(FETCH_PRACTICE_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_PRACTICE_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchPastPracticeAPI = async (teamId: string, setState: Function, snackbar: Function) => {
    const events: any = [];
    try {
        const docs = await fetchPastPracticesFirestoreAPI(teamId);
        docs.forEach((doc) => {
            if (doc.exists) {
                events.push({ ...doc.data() });
            }
        });
        setState({ type: 'fetchPastPractice', events });
    } catch (error) {
        sendErrorAnalytics(FETCH_PRACTICE_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_PRACTICE_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchLimitedUpcomingEventsAndPracticeAPI = async (teamId: string, count: number, setState: Function, snackbar: Function) => {
    const events: any = [];
    try {
        const docs = await fetchLimitedUpcomingEventsAndPracticeFirestoreAPI(teamId, count);
        docs.forEach((doc) => {
            if (doc.exists) {
                events.push({ ...doc.data() });
            }
        });
        setState({ type: 'fetchUpcomingEvents', events });
    } catch (error) {
        sendErrorAnalytics(FETCH_EVENTS_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_EVENTS_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchLimitedPastEventsAndPracticeAPI = async (teamId: string, count: number, setState: Function, snackbar: Function) => {
    const events: any = [];
    try {
        const docs = await fetchLimitedPastEventsAndPracticeFirestoreAPI(teamId, count);
        docs.forEach((doc) => {
            if (doc.exists) {
                events.push({ ...doc.data() });
            }
        });
        setState({ type: 'fetchPastEvents', events });
    } catch (error) {
        sendErrorAnalytics(FETCH_EVENTS_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_EVENTS_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchLimitedUpcomingEventsAPI = async (teamId: string, count: number, setState: Function, snackbar: Function) => {
    const events: any = [];
    try {
        const docs = await fetchLimitedUpcomingEventsFirestoreAPI(teamId, count);
        docs.forEach((doc) => {
            if (doc.exists) {
                events.push({ ...doc.data() });
            }
        });
        setState({ type: 'fetchUpcomingEvents', events });
    } catch (error) {
        sendErrorAnalytics(FETCH_EVENTS_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_EVENTS_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchLimitedPastEventsAPI = async (teamId: string, count: number, setState: Function, snackbar: Function) => {
    const events: any = [];
    try {
        const docs = await fetchLimitedPastEventsFirestoreAPI(teamId, count);
        docs.forEach((doc) => {
            if (doc.exists) {
                events.push({ ...doc.data() });
            }
        });
        setState({ type: 'fetchPastEvents', events });
    } catch (error) {
        sendErrorAnalytics(FETCH_EVENTS_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_EVENTS_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchLimitedUpcomingPracticeAPI = async (teamId: string, count: number, setState: Function, snackbar: Function) => {
    const events: any = [];
    try {
        const docs = await fetchLimitedUpcomingPracticeFirestoreAPI(teamId, count);
        docs.forEach((doc) => {
            if (doc.exists) {
                events.push({ ...doc.data() });
            }
        });
        setState({ type: 'fetchUpcomingPractice', events });
    } catch (error) {
        sendErrorAnalytics(FETCH_EVENTS_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_EVENTS_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchLimitedPastPracticeAPI = async (teamId: string, count: number, setState: Function, snackbar: Function) => {
    const events: any = [];
    try {
        const docs = await fetchLimitedPastPracticeFirestoreAPI(teamId, count);
        docs.forEach((doc) => {
            if (doc.exists) {
                events.push({ ...doc.data() });
            }
        });
        setState({ type: 'fetchPastPractice', events });
    } catch (error) {
        sendErrorAnalytics(FETCH_EVENTS_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_EVENTS_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchEventTitleAPI = async (eventId: string, setState: Function, snackbar: Function) => {
    try {
        const doc = await fetchEventFirestoreAPI(eventId);
        if (doc.exists && doc.data() !== null && doc.data() !== undefined) {
            const event = doc.data();
            setState({ type: 'fetchEventTitle', title: event?.title, eventType: event?.eventType });
        } else {
            sendErrorAnalytics(EVENT_DOES_NOT_EXIST);
            setState({ type: 'setError' });
            if (optimXTesting) {
                snackbar(EVENT_DOES_NOT_EXIST, { variant: 'error' });
            }
        }
    } catch (error) {
        sendErrorAnalytics(FETCH_EVENT_ERROR);
        setState({ type: 'setError' });
        if (optimXTesting) {
            snackbar(FETCH_EVENT_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchEventAPI = async (teamId: string, eventId: string, setState: Function, snackbar: Function) => {
    try {
        const doc = await fetchEventFirestoreAPI(eventId);
        if (doc.exists && doc.data() !== null && doc.data() !== undefined) {
            const event = doc.data();
            const tags = await databaseTagsToLocalTags(event?.tagIds, event?.tagReferences, event?.tagTypes, teamId);
            setState({ type: 'fetchEvent',
                title: event?.title,
                featureImage: event?.featureImage,
                timeOfEvent: event?.timeOfEvent,
                endTimeOfEvent: event?.endTimeOfEvent,
                venue: event?.venue,
                notes: event?.notes,
                tags,
                published: event?.published,
                eventType: event?.eventType,
                seasonId: event?.seasonId,
                articleId: event?.articleId,
                galleryId: event?.galleryId });
        } else {
            sendErrorAnalytics(EVENT_DOES_NOT_EXIST);
            setState({ type: 'setError' });
            if (optimXTesting) {
                snackbar(EVENT_DOES_NOT_EXIST, { variant: 'error' });
            }
        }
    } catch (error) {
        sendErrorAnalytics(FETCH_EVENT_ERROR);
        setState({ type: 'setError' });
        if (optimXTesting) {
            snackbar(FETCH_EVENT_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};
